// extracted by mini-css-extract-plugin
module.exports = {"Posts":"Posts_Posts__27qcW","Message":"Posts_Message__3C-IX","NextPageLoader":"Posts_NextPageLoader__1Gsxg"};